export function Eyebrow({ children, dark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="eyebrow">
      <span className="h-px w-8 bg-cyan" />
      <span
        className={`text-xs md:text-sm font-semibold tracking-[0.22em] uppercase ${
          dark ? "text-cyan" : "text-tech"
        }`}
      >
        {children}
      </span>
    </div>
  );
}
